/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-02-03 14:11:36
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-02-14 02:40:57
 * @FilePath     : \pxb7-front-pc\youxi\src\components\LeaveMsg\index.jsx
 * @Description  : Description
 */

import "./index.css";
import { leaveMsgApi } from "@/request/API";
import Success from "./Success";

export default {
  name: "LeaveMsgTemp",
  data() {
    return {
      goodCode: "",
      content: "",
      showSuccess: false
    };
  },
  computed: {
    canClick() {
      return !!this.goodCode.trim() && !!this.content.trim();
    }
  },
  methods: {
    closeLeaveMsgModal() {
      window.close();
    },
    submit() {
      const reg = /^[0-9a-zA-Z]+$/;
      const goodCode = this.goodCode.trim();
      if (goodCode && !reg.test(goodCode)) {
        this.$alert("商品编码只能是字母和数字！", "提示");
        return false;
      }
      leaveMsgApi({
        good_sn: goodCode,
        content: this.content.trim(),
        user_id: JSON.parse(localStorage.getItem('userData')).user_id || ''
      }).then(res => {
        this.showSuccess = res.code === 200
      }).catch(err=> {
        this.$message({
          type: 'error',
          message: err.msg || '提交失败，请重新提交'
        })
      })
    }
  },
  render() {
    return (
      <div class="leave-msg-bg">
        <div class="leave-msg-wrap">
          <div class="leave-msg--header">
            <div class="leave-msg--title">
              <i class="leave-msg--icon el-icon-chat-dot-round"></i>留言板
            </div>
            <div class="leave-msg--btn-close">
              <i
                class="leave-msg--icon el-icon-circle-close"
                onClick={this.closeLeaveMsgModal}
              ></i>
            </div>
          </div>
          {this.showSuccess ? (
            <Success />
          ) : (
            <div class="leave-msg--body">
              <div class="form-item">
                <div class="label">商品编码</div>
                <el-input
                  size="small"
                  placeholder="请填写商品编码（必填）"
                  v-model={this.goodCode}
                  clearable
                  maxlength="8"
                  show-word-limit
                ></el-input>
              </div>
              <div class="form-item">
                <div class="label">留言内容</div>
                <el-input
                  type="textarea"
                  placeholder="请填写您的留言内容，如价格需求，其他联系方式等（必填）"
                  v-model={this.content}
                  clearable
                  rows="7"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </div>
              <div class="leave-msg--tips">
                <i class="leave-msg--icon__tips el-icon-warning"></i>
                我们会通过APP内消息或电话联系您，请注意查看
              </div>
              <div class="leave-msg--btn__submit">
                <el-button
                  type="primary"
                  onClick={this.submit}
                  disabled={!this.canClick}
                >
                  提交
                </el-button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
};
